var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 78,
    viewBox: "0 0 68 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21994 0.727609L66.5166 36.4859C66.9559 36.7431 67.3202 37.1107 67.5734 37.5523C67.8266 37.9939 67.9598 38.494 67.9598 39.003C67.9598 39.512 67.8266 40.0122 67.5734 40.4538C67.3202 40.8953 66.9559 41.263 66.5166 41.5201L5.21994 77.2785C4.77584 77.5376 4.27111 77.6748 3.75692 77.676C3.24273 77.6772 2.73735 77.5425 2.29201 77.2855C1.84666 77.0285 1.47718 76.6583 1.221 76.2124C0.964827 75.7666 0.831067 75.261 0.833279 74.7468V3.24761C0.833127 2.73441 0.968388 2.23026 1.2254 1.78605C1.48242 1.34185 1.85209 0.973324 2.29708 0.717687C2.74208 0.46205 3.24665 0.328353 3.75985 0.330095C4.27304 0.331837 4.77669 0.468957 5.21994 0.727609Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c410f67f.svg";
export { ForwardRef as ReactComponent };